import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "@/store";
import { logout } from "@/store/slices/authSlice";
import { useNotification } from "@/context/NotificationContext";
import api from "@/api/axios";
import { DELETE_CONFIRM_KEYWORD } from "@/constants";

export function useAccount() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector((s) => s.auth.user);
  const { notify } = useNotification();

  const [profile, setProfile] = useState<any>(null);
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(true);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");

  useEffect(() => {
    api
      .get("/users/me")
      .then((r) => {
        setProfile(r.data);
        setUsername(r.data.username || "");
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const handleUpdateUsername = async () => {
    await api.patch("/users/me", { username });
    notify(t("common.success"), "success");
  };

  const handleLogout = async () => {
    await dispatch(logout());
    navigate("/");
  };

  const handleDelete = async () => {
    try {
      await api.delete("/users/me");
      await dispatch(logout());
      navigate("/");
    } catch {
      notify(t("errors.generic"), "error");
    }
  };

  const canDelete = confirmText === DELETE_CONFIRM_KEYWORD;

  return {
    user,
    profile,
    username,
    setUsername,
    loading,
    deleteOpen,
    setDeleteOpen,
    confirmText,
    setConfirmText,
    handleUpdateUsername,
    handleLogout,
    handleDelete,
    canDelete,
  };
}
